export class UpdateEventField {
  static readonly type = '[Event] Update Field'
  constructor(
    public readonly section: 'base' | 'sr-event' | 'assistanceEvent',
    public readonly field: string,
    public readonly value: unknown,
  ) {}
}

export class ResetEvent {
  static readonly type = '[Event] Reset'
}
